import AddressSchema from '../Contacts/AddressSchema';

export default {
    title: "Add Dependent",
    type: "object",
    required: ["relationshipTypeId", "nameFirst", "nameLast", "usSocialSecurityNumber", "dateOfBirth", "gender", "effectiveDate", "isUSCitizen", "isUSResident", "isDisabled", "isMedicareEligible", "isFullTimeCollegeStudent"],
    properties: {
        relationshipTypeId: {
            type: "number",
            title: "Relationship Type",
            enum: [2, 4],
            enumNames: ['Child', 'Other Legal Dependent']
        },
        nameFirst: {
            type: "string",
            title: "First Name"
        },
        nameMiddle: {
            type: "string",
            title: "Middle Name"
        },
        nameLast: {
            type: "string",
            title: "Last Name"
        },
        usSocialSecurityNumber: {
            type: "string",
            title: "U.S. Social Security Number"
        },
        dateOfBirth: {
            type: "string",
            format: "date",
            title: "Date of Birth"
        },
        gender: {
            type: "string",
            title: "Gender",
            enum: ['M', 'F'],
            enumNames: ['Male', 'Female']
        },
        effectiveDate: {
            type: "string",
            format: "date",
            title: "Relationship Effective Date"
        },
        terminateDate: {
            type: "string",
            format: "date",
            title: "Relationship End Date"
        },
        dateOfDeath: {
            type: "string",
            format: "date",
            title: " "
        },
        isUSCitizen: {
            type: "boolean",
            title: "U.S. Citizen?"
        },
        isUSResident: {
            type: "boolean",
            title: "U.S. Resident?"
        },
        racialHeritage: {
            type: "string",
            title: "Ethnicity",
            enum: ['American Indian or Alaska Native', 'Asian', 'Black or African American', 'Hispanic or Latino', 'Native Hawaiian or Other Pacific Islander', 'White', 'Two or More Races (Not Hispanic or Latino)', 'I do not wish to disclose']
        },
        isDisabled: {
            type: "boolean",
            title: "Disabled?"
        },
        isMedicareEligible: {
            type: "boolean",
            title: "Medicare Eligible?"
        },
        medicareNumber: {
            type: "string",
            title: "Medicare Number"
        },
        isFullTimeCollegeStudent: {
            type: "boolean",
            title: "Full-time College Student?"
        },
        addressMailing: {
            type: "object",
            title: "Address (if different from Employee)",
            properties: AddressSchema
        }
    }
};